import { React, Loader, AppTextLabel } from '@@commons';
import { withI18nHelper } from '@inwink/i18n';
import { Entities } from '@inwink/entities/entities';

import './pageloader.less';

type LoaderDisplay = "ring" | "bubbles";

interface IPageLoaderProps {
    i18nHelper?: Entities.i18nHelper;
    display?: LoaderDisplay;
    data?: { message: string };
}

@withI18nHelper()
export class PageLoader extends React.Component<IPageLoaderProps, any> {
    render() {
        const display: LoaderDisplay = this.props.display ?? "bubbles";
        const messageInLoader = display === "ring";
        const message = this.props.data?.message || "page.loading";
        return <div className="pageloader">
            <Loader display={display}
                message={messageInLoader ? this.props.i18nHelper.translate(message) : null} />
            {!messageInLoader && <AppTextLabel className="pageloadermessage" i18n={message} />}
        </div>;
    }
}
